module.exports = __webpack_public_path__ + "static/media/svg-3.f2eabf27.svg";